import React, { Component } from 'react';

import Header from '../../components/Header/Header';
import Navigation from '../../components/Navigation/Navigation';
import faqHeaderBg from '../../assets/images/faqBg.png'
import Footer from '../../components/Footer'
import CategoryItemIcon from "../../components/Calculator-board/Category-item/Category-item-icon";
import productdetailsbg from "../../assets/images/productdetailsbg.png";
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux'
// import {FaqContent}  from './faqContent'
import {
    setActiveLanguage,
} from 'react-localize-redux';

import './ProductDetails.css'

class ProductDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: []
        }
    }

    componentWillMount() {
        this.props.dispatch(setActiveLanguage(localStorage.getItem('currentLanguage')))
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }


    render() {
        return (
            <div className="product-details-container">
                <div className="Head">
                    <Header />
                    <Navigation />
                </div>
                <div className="product-details-container-header">
                    <div className="product-details-container-header-background">
                        <img src={productdetailsbg} alt="Compulsory Insurance Center" />
                    </div>
                    <div className="product-details-header-wrapper"></div>
                    <div className="product-details-header-content">
                        <div className="product-details-header-text">
                            <h1> {this.props.translate("product-description-header")} </h1>
                            <h5>{this.props.translate("PolicySearchPortalByIndividualPersons")}</h5>
                        </div>
                    </div>
                </div>

                <div className="product-details-content">
                    <div className="product-details-text">
                        <h3>{this.props.translate("product-description-header")}</h3>
                        <span>
                            {this.props.translate("product-description-text-content-1")}
                        </span>
                        <span>
                            {this.props.translate("product-description-text-content-2")}
                        </span>
                    </div>
                    <div className="Insurance-packages">
                        <div className="Insurance-packages-header">
                            <span>
                                {this.props.translate("product-description-insurance-packages")}
                            </span>
                        </div>
                        <div className="Insurance-packages-content">
                            <div className="Insurance-packages-content-header">
                                <div className="Insurance-packages-icon">
                                    <span> {this.props.translate("product-description-term")} </span>
                                </div>
                                <div className="Insurance-packages-icon">
                                    <CategoryItemIcon iconName="000000000000001" width={90} />
                                </div>

                                <div className="Insurance-packages-icon">
                                    <CategoryItemIcon iconName="000000000000002" width={90} />
                                </div>

                                <div className="Insurance-packages-icon">
                                    <CategoryItemIcon iconName="000000000000003" width={90} />
                                </div>

                                <div className="Insurance-packages-icon">
                                    <CategoryItemIcon iconName="000000000000004" width={90} />
                                </div>

                                <div className="Insurance-packages-icon">
                                    <CategoryItemIcon iconName="000000000000005" width={90} />
                                </div>

                                <div className="Insurance-packages-icon">
                                    <CategoryItemIcon iconName="000000000000006" width={90} />
                                </div>
                            </div>

                            <div className="Insurance-packages-days-prices">
                                <div className="Insurance-packages-day-prices-item"><span>15 {this.props.translate("day")}</span></div>
                                <div className="Insurance-packages-day-prices-item"><span>20</span></div>
                                <div className="Insurance-packages-day-prices-item"><span>30</span></div>
                                <div className="Insurance-packages-day-prices-item"><span>45</span></div>
                                <div className="Insurance-packages-day-prices-item"><span>60</span></div>
                                <div className="Insurance-packages-day-prices-item"><span>14</span></div>
                                <div className="Insurance-packages-day-prices-item"><span>25</span></div>
                            </div>
                            <div className="Insurance-packages-days-prices">
                                <div className="Insurance-packages-day-prices-item"><span>30 {this.props.translate("day")}</span></div>
                                <div className="Insurance-packages-day-prices-item"><span>35</span></div>
                                <div className="Insurance-packages-day-prices-item"><span>50</span></div>
                                <div className="Insurance-packages-day-prices-item"><span>75</span></div>
                                <div className="Insurance-packages-day-prices-item"><span>100</span></div>
                                <div className="Insurance-packages-day-prices-item"><span>25</span></div>
                                <div className="Insurance-packages-day-prices-item"><span>45</span></div>
                            </div>
                            <div className="Insurance-packages-days-prices">
                                <div className="Insurance-packages-day-prices-item"><span>90 {this.props.translate("day")}</span></div>
                                <div className="Insurance-packages-day-prices-item"><span>70</span></div>
                                <div className="Insurance-packages-day-prices-item"><span>90</span></div>
                                <div className="Insurance-packages-day-prices-item"><span>140</span></div>
                                <div className="Insurance-packages-day-prices-item"><span>170</span></div>
                                <div className="Insurance-packages-day-prices-item"><span>40</span></div>
                                <div className="Insurance-packages-day-prices-item"><span>70</span></div>
                            </div>
                            <div className="Insurance-packages-days-prices">
                                <div className="Insurance-packages-day-prices-item"><span>1 {this.props.translate("year")}</span></div>
                                <div className="Insurance-packages-day-prices-item"><span>215</span></div>
                                <div className="Insurance-packages-day-prices-item"><span>295</span></div>
                                <div className="Insurance-packages-day-prices-item"><span>480</span></div>
                                <div className="Insurance-packages-day-prices-item"><span>610</span></div>
                                <div className="Insurance-packages-day-prices-item"><span>145</span></div>
                                <div className="Insurance-packages-day-prices-item"><span>250</span></div>
                            </div>
                        </div>
                        <div className="Insurance-packages-footer">
                            <span>{this.props.translate("product-description-pirces-are-national-currency")}</span>
                        </div>

                    </div>

                    <div className="product-details-text">
                        <h3>
                            {this.props.translate("product-description-text-content-3")}
                        </h3>

                        <span>
                            {this.props.translate("product-description-text-content-4")}
                        </span>

                        <span>
                            {this.props.translate("product-description-text-content-5")}
                        </span>

                        <span>
                            {this.props.translate("product-description-text-content-6")}
                        </span>

                        <span>
                            {this.props.translate("product-description-text-content-7")}
                        </span>

                        <span>
                            {this.props.translate("product-description-text-content-8")}
                        </span>

                        <span>
                            {this.props.translate("product-description-text-content-9")}
                        </span>

                        <span>
                            {this.props.translate("product-description-text-content-10")}
                        </span>


                    </div>
                </div>

                <Footer />

            </div>
        )
    }
}
const mapStateToProps = state => ({
    translate: getTranslate(state.locale),

})
export default connect(mapStateToProps)(ProductDetails)



// WEBPACK FOOTER //
// ./src/pages/ProductDetails/ProductDetails.js